import { format } from 'date-fns';

type NullableDateString = Date | string | null | undefined;

export const formatDate = (date: NullableDateString) => date && format(date, 'dd.MM.yyyy');

export const formatDateTime = (date: NullableDateString) => date && format(date, "dd.MM.yyyy, HH:mm 'Uhr'");
